import { render, staticRenderFns } from "./CreateOrderPanel.vue?vue&type=template&id=5163dd31&scoped=true"
import script from "./CreateOrderPanel.vue?vue&type=script&lang=js"
export * from "./CreateOrderPanel.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderPanel.vue?vue&type=style&index=0&id=5163dd31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163dd31",
  null
  
)

export default component.exports